import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FileUtilsService {

  constructor() { }

  isPDF = (file : string) : boolean => this.getFileExtension(file) == "pdf";

	getFileExtension(fileName : string) : string{
		if(!fileName || fileName.indexOf(".") == -1) return;
		
    var splits = fileName.split(".");
		return splits[splits.length - 1].toLowerCase();
	};
  
}
